module.exports = {"610326001":"首善街道","610326101":"横渠镇","610326102":"槐芽镇","610326103":"汤峪镇","610326104":"常兴镇","610326105":"金渠镇","610326106":"营头镇","610326107":"齐镇","610326400":"陕西省太白山旅游区","610326401":"红河谷森林公园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610326.json
// module id = 2800
// module chunks = 0